document.addEventListener("DOMContentLoaded", () => {
  initializePriceRangeFilters();
});

const initializePriceRangeFilters = () => {
  const priceRangeContainers = document.querySelectorAll(
    ".price-range-container"
  );

  priceRangeContainers.forEach((container) => {
    const slider = container.querySelector(".price-range-slider");
    const minInput = container.querySelector(".price-range-input--min");
    const maxInput = container.querySelector(".price-range-input--max");
    const applyButton = container.querySelector(".price-range-apply");

    if (!slider || !minInput || !maxInput) return;

    const minValue = parseFloat(minInput.min);
    const maxValue = parseFloat(maxInput.max);
    const currentMin = parseFloat(minInput.value) || minValue;
    const currentMax = parseFloat(maxInput.value) || maxValue;

    // Initialize noUiSlider
    if (typeof noUiSlider !== "undefined" && !slider.noUiSlider) {
      noUiSlider.create(slider, {
        start: [currentMin, currentMax],
        connect: true,
        range: {
          min: minValue,
          max: maxValue,
        },
        step: 1,
        format: {
          to: (value) => Math.round(value),
          from: (value) => Number(value),
        },
      });

      // Update inputs when slider changes
      slider.noUiSlider.on("update", (values, handle) => {
        if (handle === 0) {
          minInput.value = values[0];
        } else {
          maxInput.value = values[1];
        }
      });

      // Update slider when inputs change
      minInput.addEventListener("change", () => {
        const value = parseFloat(minInput.value);
        if (!isNaN(value)) {
          slider.noUiSlider.set([value, null]);
        }
      });

      maxInput.addEventListener("change", () => {
        const value = parseFloat(maxInput.value);
        if (!isNaN(value)) {
          slider.noUiSlider.set([null, value]);
        }
      });
    }

    // Handle apply button click (for standalone price range filters)
    if (applyButton) {
      applyButton.addEventListener("click", () => {
        applyPriceRangeFilter(minInput, maxInput, applyButton);
      });
    }

    // Handle enter key in inputs
    [minInput, maxInput].forEach((input) => {
      input.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          if (applyButton) {
            applyButton.click();
          } else {
            // For filter drawer, trigger the drawer's apply button
            const drawerApplyButton = document.querySelector(".filter-drawer__apply");
            if (drawerApplyButton) {
              drawerApplyButton.click();
            }
          }
        }
      });
    });
  });
};

const applyPriceRangeFilter = (minInput, maxInput, applyButton) => {
  const min = parseFloat(minInput.value);
  const max = parseFloat(maxInput.value);
  const minValue = parseFloat(minInput.min);
  const maxValue = parseFloat(maxInput.max);
  
  if (isNaN(min) || isNaN(max) || min > max) {
    return;
  }
  
  // Build URL based on context (collection or search)
  let url;
  if (applyButton.dataset.collectionUrl) {
    // Collection page
    url = new URL(applyButton.dataset.collectionUrl, window.location.origin);
  } else if (applyButton.dataset.searchUrl) {
    // Search page
    url = new URL(applyButton.dataset.searchUrl, window.location.origin);
    if (applyButton.dataset.searchTerms) {
      url.searchParams.set("q", applyButton.dataset.searchTerms);
    }
  } else {
    return;
  }
  
  // Get existing parameters
  const currentParams = new URLSearchParams(window.location.search);
  
  // Copy all existing parameters except the price filter
  currentParams.forEach((value, key) => {
    if (!key.includes("filter.v.price") && key !== "q") {
      url.searchParams.set(key, value);
    }
  });
  
  // Add price filter parameters
  if (min > minValue || max < maxValue) {
    url.searchParams.set("filter.v.price.gte", Math.floor(min));
    url.searchParams.set("filter.v.price.lte", Math.ceil(max));
  }
  
  // Navigate to the filtered URL
  window.location.href = url.toString();
};

// Export function for filter drawer integration
window.getPriceRangeValues = () => {
  const containers = document.querySelectorAll(".filter-drawer .price-range-container");
  const priceFilters = [];
  
  containers.forEach((container) => {
    const minInput = container.querySelector(".price-range-input--min");
    const maxInput = container.querySelector(".price-range-input--max");
    
    if (minInput && maxInput) {
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const minValue = parseFloat(minInput.min);
      const maxValue = parseFloat(maxInput.max);
      
      if (!isNaN(min) && !isNaN(max) && min <= max && (min > minValue || max < maxValue)) {
        priceFilters.push({
          min: Math.floor(min),
          max: Math.ceil(max)
        });
      }
    }
  });
  
  return priceFilters;
};

// Re-initialize when facets are updated (for AJAX implementations)
document.addEventListener("facets:updated", () => {
  initializePriceRangeFilters();
});

// Re-initialize when filter drawer opens
document.addEventListener("filter-drawer:opened", () => {
  setTimeout(() => {
    initializePriceRangeFilters();
  }, 100);
});
